/**
 * BILLAUR WICKS - LUXURY THEME JAVASCRIPT
 * Real Shopify Cart API integration
 */
document.addEventListener('DOMContentLoaded', () => {
  initDrawer();
  initAccordion();
  initMobileMenu();
  initCartLogic();
});

// 1. Drawer Logic
function initDrawer() {
  const drawer = document.getElementById('bw-cart-drawer');
  if (!drawer) return;

  document.querySelectorAll('.js-drawer-open').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      fetchAndRenderCart();
      openCartDrawer();
    });
  });

  document.querySelectorAll('.js-drawer-close').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeCartDrawer();
    });
  });
}

function openCartDrawer() {
  const drawer = document.getElementById('bw-cart-drawer');
  if (drawer) {
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('bw-cart-drawer');
  if (drawer) {
    drawer.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// 2. Accordion Logic
function initAccordion() {
  const toggles = document.querySelectorAll('.js-accordion-toggle');
  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.bw-accordion-item');
      const icon = toggle.querySelector('.bw-accordion-icon');
      const isExpanded = item.classList.contains('active');

      document.querySelectorAll('.bw-accordion-item').forEach(other => {
        other.classList.remove('active');
        const otherIcon = other.querySelector('.bw-accordion-icon');
        if (otherIcon) otherIcon.innerHTML = '+';
      });

      if (!isExpanded) {
        item.classList.add('active');
        if (icon) icon.innerHTML = '&minus;';
      }
    });
  });
}

// 3. Mobile Menu Logic
function initMobileMenu() {
  const toggle = document.querySelector('.js-mobile-menu-toggle');
  const drawer = document.querySelector('.js-mobile-drawer');
  const closeBtn = document.querySelector('.js-mobile-menu-close');

  if (toggle && drawer) {
    toggle.addEventListener('click', () => drawer.classList.add('active'));
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', () => drawer.classList.remove('active'));
  }
}

// 4. Real Shopify Cart Logic
function initCartLogic() {
  // Fetch real cart on page load to update badge
  fetchAndRenderCart();

  // Handle Add To Bag buttons (data-variant-id required)
  document.querySelectorAll('.js-add-to-bag-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      addToCartAPI(variantId, 1);
    });
  });
}

// Fetch cart from Shopify and render
function fetchAndRenderCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      renderCartUI(cart);
    })
    .catch(err => console.error('Cart fetch error:', err));
}

// Add item via Shopify Cart API
function addToCartAPI(variantId, quantity) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
    .then(res => res.json())
    .then(() => {
      fetchAndRenderCart();
      openCartDrawer();
    })
    .catch(err => console.error('Add to cart error:', err));
}

// Update item quantity via Shopify Cart API
function updateQuantity(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
    .then(res => res.json())
    .then(cart => {
      renderCartUI(cart);
    })
    .catch(err => console.error('Update quantity error:', err));
}

// Render cart UI from real Shopify cart object
function renderCartUI(cart) {
  const itemsContainer = document.getElementById('cart-drawer-items');
  const countBadges    = document.querySelectorAll('.js-cart-count');
  const drawerCount    = document.getElementById('cart-item-count');
  const subtotalEl     = document.getElementById('cart-subtotal-price');

  const totalItems = cart.item_count;
  const subtotal   = cart.total_price / 100; // Shopify returns price in paise

  // Update badge — hide if empty
  countBadges.forEach(el => {
    el.textContent = totalItems;
    el.style.display = totalItems > 0 ? 'flex' : 'none';
  });

  if (drawerCount) drawerCount.textContent = totalItems;
  if (subtotalEl)  subtotalEl.textContent  = `₹ ${subtotal.toLocaleString('en-IN')}`;

  // Milestone Bar
  updateMilestoneBar(subtotal);

  // Items List
  if (!itemsContainer) return;

  if (cart.items.length === 0) {
    itemsContainer.innerHTML = `
      <div class="bw-cart-empty-message">
        <p>Your bag is currently empty.</p>
        <a href="/collections/all" class="bw-btn-secondary js-drawer-close" onclick="closeCartDrawer()">Start Exploring</a>
      </div>
    `;
  } else {
    let html = '';
    cart.items.forEach((item, idx) => {
      const lineNumber = idx + 1;
      const itemPrice  = item.final_line_price / 100;
      const imgSrc     = item.image ? item.image : '';
      html += `
        <div class="bw-cart-item">
          <img src="${imgSrc}" alt="${item.title}" class="bw-cart-item__img">
          <div class="bw-cart-item__info">
            <h4 class="bw-cart-item__title">${item.product_title}</h4>
            <div class="bw-cart-item__price">₹ ${itemPrice.toLocaleString('en-IN')}</div>
            <div class="bw-cart-item__qty">
              <button type="button" class="bw-qty-btn" onclick="updateQuantity(${lineNumber}, ${item.quantity - 1})">&minus;</button>
              <span>${item.quantity}</span>
              <button type="button" class="bw-qty-btn" onclick="updateQuantity(${lineNumber}, ${item.quantity + 1})">+</button>
            </div>
          </div>
        </div>
      `;
    });
    itemsContainer.innerHTML = html;
  }
}

/* ── MILESTONE BAR ── */
function updateMilestoneBar(subtotal) {
  const progress = document.getElementById('milestone-progress');
  const message  = document.getElementById('milestone-message');

  if (!progress || !message) return;

  const milestones = [
    { value: 599,  discount: 100,  label: '₹599' },
    { value: 1499, discount: 200,  label: '₹1,499' },
    { value: 1999, discount: 350,  label: '₹1,999' },
    { value: 2999, discount: 600,  label: '₹2,999' }
  ];

  const maxValue = milestones[milestones.length - 1].value;

  const pct = Math.min((subtotal / maxValue) * 100, 100);
  progress.style.width = pct + '%';

  const dots = [
    document.getElementById('milestone-dot-1'),
    document.getElementById('milestone-dot-2'),
    document.getElementById('milestone-dot-3'),
    document.getElementById('milestone-dot-4')
  ];
  milestones.forEach((m, i) => {
    if (dots[i]) {
      dots[i].classList.toggle('achieved', subtotal >= m.value);
    }
  });

  const rewardEls = [
    document.getElementById('reward-1'),
    document.getElementById('reward-2'),
    document.getElementById('reward-3'),
    document.getElementById('reward-4')
  ];
  milestones.forEach((m, i) => {
    if (rewardEls[i]) {
      rewardEls[i].classList.toggle('achieved', subtotal >= m.value);
    }
  });

  message.className = 'bw-milestone-message';
  const achieved = milestones.filter(m => subtotal >= m.value);
  const next = milestones.find(m => subtotal < m.value);

  if (subtotal === 0) {
    message.innerHTML = `🎁 Spend <strong>₹599</strong> to get <strong>₹100 OFF</strong> · <strong>₹1,499</strong> for <strong>₹200 OFF</strong> and more!`;
  } else if (!next) {
    message.classList.add('unlocked-2');
    message.innerHTML = `🎉 Maximum reward unlocked! You saved <strong>₹600</strong>!`;
  } else {
    const remaining = next.value - subtotal;
    const lastAchieved = achieved[achieved.length - 1];
    if (lastAchieved) {
      message.classList.add('unlocked-1');
      message.innerHTML = `🎉 <strong>₹${lastAchieved.discount} OFF</strong> unlocked! Add <strong>₹${remaining.toLocaleString('en-IN')}</strong> more to get <strong>₹${next.discount} OFF</strong>!`;
    } else {
      message.innerHTML = `🎁 Add <strong>₹${remaining.toLocaleString('en-IN')}</strong> more to unlock <strong>₹${next.discount} OFF</strong>!`;
    }
  }

  // Show discount & total lines in footer when a milestone is unlocked
  const discountLine  = document.getElementById('cart-discount-line');
  const totalLine     = document.getElementById('cart-total-line');
  const discountAmtEl = document.getElementById('cart-discount-amount');
  const totalPriceEl  = document.getElementById('cart-total-price');

  const lastUnlocked = achieved[achieved.length - 1];

  if (lastUnlocked && discountLine && totalLine) {
    const discount = lastUnlocked.discount;
    const total    = subtotal - discount;
    discountAmtEl.textContent = `−₹ ${discount.toLocaleString('en-IN')}`;
    totalPriceEl.textContent  = `₹ ${total.toLocaleString('en-IN')}`;
    discountLine.style.display = 'flex';
    totalLine.style.display    = 'flex';
  } else if (discountLine && totalLine) {
    discountLine.style.display = 'none';
    totalLine.style.display    = 'none';
  }
}

window.updateQuantity  = updateQuantity;
window.closeCartDrawer = closeCartDrawer;